module.exports = __webpack_public_path__ + "static/media/Voyage soffa 4-sits cozy grön miljö 2024.7215846a.jpg";